import { CategoryId } from '$/epg/categories'
import { createStore, sample } from 'effector'
import { not, or } from 'patronum'
import {
  $isFetchEpgInfoFxPending,
  fetchEpg,
} from '~/entities/epg/programs/model'
import { F, T } from '~/shared/helpers'
import { loadInitialChannelsFx } from './model'

// Skeletons for loading initial channels in category
export const $isInitialChannelsWithEpgLoading = createStore(false) // for cahnnel page with epg
export const $isInitialChannelsLoading = createStore(false) // for live module with grid

// show skeleton when initialchannels are loading
sample({
  clock: loadInitialChannelsFx,
  fn: T,
  target: [$isInitialChannelsWithEpgLoading, $isInitialChannelsLoading],
})

const isLoading = or($isFetchEpgInfoFxPending, loadInitialChannelsFx.pending)

// hide skeleton when epg is loaded or initial channels load failed
sample({
  clock: [
    $isFetchEpgInfoFxPending,
    fetchEpg,
    loadInitialChannelsFx.fail,
    isLoading,
  ],
  filter: not(isLoading),
  fn: F,
  target: $isInitialChannelsWithEpgLoading,
})

// hide grid skeleton when channels are loaded
sample({
  clock: loadInitialChannelsFx.finally,
  fn: F,
  target: $isInitialChannelsLoading,
})

// hide skeleton when favorite channels are loaded but no channels were received
// since there are no channels, we don't fetch EPG data
sample({
  clock: loadInitialChannelsFx.done,
  filter: ({ params, result }) => {
    return params.categoryId === CategoryId.Favorite && result.length === 0
  },
  fn: F,
  target: [$isInitialChannelsWithEpgLoading, $isInitialChannelsLoading],
})
